import React from 'react';
import LessonHome from '../LessonHome';

const Lesson2 = (props) => {

    return ( 
        <LessonHome
            {...props}
        />        
     );
}
 
export default Lesson2;